import { render, staticRenderFns } from "./SalesByModifier.vue?vue&type=template&id=480d6562&scoped=true"
import script from "./SalesByModifier.vue?vue&type=script&lang=js"
export * from "./SalesByModifier.vue?vue&type=script&lang=js"
import style0 from "./SalesByModifier.vue?vue&type=style&index=0&id=480d6562&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480d6562",
  null
  
)

export default component.exports